import React from "react";
import { Helmet } from "react-helmet";
import { bool, func, node, string } from "prop-types";

import { resizableRoute } from "pages/_components/Resizable";
import Header from "pages/_components/header/Header";
import ViewTitle from "pages/_components/header/components/ViewTitle";
import ArrowBack from "pages/_components/header/components/ArrowBack";

import * as i18n from "util/i18n";

const CompoundHeader = (props) => {
    const {
        id,
        backLinkTo,
        onClickBack,
        children,
        infoComponents,
        defaultTitle,
        metaTitle,
        showLabel,
        noBack,
        className,
        ticket,
        showTitle,
    } = props;

    let defaultValueTitle;

    if (id && metaTitle) {
        defaultValueTitle = id;
    } else {
        defaultValueTitle = defaultTitle;
    }

    return (
        <>
            <Helmet>
                <title>{`Bi-Bank - ${i18n.get(metaTitle || id, defaultValueTitle)}`}</title>
            </Helmet>
            <Header className={`${className} ${ticket && "ticket-header"}`}>
                {!noBack && (
                    <div className="toolbar-item toolbar-view-back">
                        <ArrowBack backLinkTo={backLinkTo} onClickBack={onClickBack} showLabel={showLabel} />
                    </div>
                )}
                {showTitle && (
                    <div className="toolbar-item view-title">
                        {(id || defaultValueTitle || metaTitle) && (
                            <ViewTitle id={id} defaultValue={i18n.get(metaTitle, defaultValueTitle)} />
                        )}
                        {infoComponents}
                    </div>
                )}
                {children}
            </Header>
        </>
    );
};

CompoundHeader.propTypes = {
    backLinkTo: string,
    onClickBack: func,
    id: string.isRequired,
    children: node,
    infoComponents: node,
    defaultTitle: string,
    metaTitle: string,
    showLabel: bool,
    noBack: bool,
    className: string,
    ticket: bool,
    showTitle: bool,
};

CompoundHeader.defaultProps = {
    backLinkTo: "",
    onClickBack: null,
    children: null,
    infoComponents: null,
    defaultTitle: null,
    metaTitle: "",
    showLabel: true,
    noBack: false,
    className: "",
    ticket: false,
    showTitle: true,
};

export default resizableRoute(CompoundHeader);
